import { mockApp } from '@/mocks/home';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-[900px] mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-10 flex flex-col lg:flex-row items-center gap-8">
            <div className="flex-shrink-0">
              <div className="w-32 h-32 md:w-40 md:h-40 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Manga%20reading%20app%20icon%20design%2C%20cute%20manga%20style%20character%20on%20warm%20gradient%20background%2C%20minimal%20modern%20app%20icon%20style%2C%20soft%20warm%20orange%20and%20coral%20tones%2C%20clean%20vector%20illustration%2C%20friendly%20and%20inviting%20design&width=400&height=400&seq=manga-app-icon&orientation=squarish"
                  alt="虫虫漫画App图标"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            <div className="flex-1 text-center lg:text-left">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-950 mb-3">移动阅读</h2>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">{mockApp.description}</p>

              <div className="flex flex-wrap gap-3 justify-center lg:justify-start mb-6">
                {mockApp.features.map((feat, i) => (
                  <span key={i} className="flex items-center gap-1.5 text-xs text-foreground-700 bg-background-100 px-3 py-1.5 rounded-full">
                    <i className="ri-check-line text-accent-500 text-sm"></i>
                    {feat}
                  </span>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#hero"
                  className="px-6 py-2.5 bg-foreground-900 text-background-50 rounded-md text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer no-underline whitespace-nowrap flex items-center gap-2"
                >
                  <i className="ri-android-line"></i>
                  Android 下载
                </a>
                <a
                  href="#hero"
                  className="px-6 py-2.5 bg-foreground-900 text-background-50 rounded-md text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer no-underline whitespace-nowrap flex items-center gap-2"
                >
                  <i className="ri-apple-line"></i>
                  iOS 下载
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}